import React from 'react';

import { useInvertedLocalize } from '../../../shared/utils/localization';
import { type ProviderEditProps, Providers, type SamlProvider } from '../types';

import SAMLEditView from './SAMLEditView';

interface Props {
  activeProvider: Providers | null;
  isFullwidth?: boolean;
  saml: ProviderEditProps<SamlProvider>;
}

/** Switching component that will render the correct provider based on activeProvider */
export function ProviderEditView({
  activeProvider,
  saml,
  isFullwidth,
}: Props): JSX.Element {
  const l = useInvertedLocalize();

  switch (activeProvider) {
    case Providers.SAML:
      return <SAMLEditView props={saml} isFullwidth={!!isFullwidth} />;
    default:
      return <>{l('Unknown Provider')}</>;
  }
}
